/* Release notes shown once per version on the orders list, newest first.
   Bump the version in package.json with every entry: the app compares it
   with the last version the device has seen. Keep each note one sentence,
   written for the person on the floor. */
export const CHANGELOG = [
  {
    version: '1.15.2',
    date: '2026-11-03',
    title: 'First line in view',
    notes: ['Opening an order now always starts at the top: the first product no longer hides under the order bar.'],
  },
  {
    version: '1.15.0',
    date: '2026-11-03',
    title: 'Easier on the floor',
    notes: [
      'Delivery notes: Add all when Inny finds several other orders on a note, and None in this delivery to clear them.',
      'Receiving: lines still to count come first, the screen follows what you scan, and a verdict says when a carton is fragile.',
      'The phone back button now closes the sheet on top, and Back on a delivery note returns to your receipt.',
      'Dates show the year when it is not this year, a note problem is no longer cut off, and the app opens without a connection.',
    ],
  },
  {
    version: '1.14.2',
    date: '2026-11-03',
    title: 'Fewer lost notes and counts',
    notes: [
      'Delivery notes: if Odoo refuses the note, your photos stay on screen and nothing is marked received, so you can try again.',
      'Delivery notes: pressing Save again after a lost connection no longer stamps the order twice or prints the labels twice.',
      'A receipt that goes through only in part now keeps the count of what did not go through.',
      'Claims and notes cut off by an app update now start again by themselves.',
    ],
  },
  {
    version: '1.14.1',
    date: '2026-11-03',
    title: 'Safer counting',
    notes: [
      'A scan with a line open no longer presses a button on screen: it closes the line and counts the carton, and it does nothing on the other sheets.',
      'Confirming again after a lost connection no longer books twice: Inny sees it is already in Odoo and puts that count back to zero.',
      'A failed receipt now has a Try again button.',
      'Typing a quantity: tapping the field keeps what you typed, and leaving it empty keeps the count.',
    ],
  },
  {
    version: '1.14.0',
    date: '2026-11-03',
    title: 'No delivery note',
    notes: [
      'Delivery notes: tick No delivery note when the goods came without paperwork, pick the order, and save. The order is received and the office is told to look for the paperwork.',
    ],
  },
  {
    version: '1.13.2',
    date: '2026-11-03',
    title: 'Delivery notes without a label printer',
    notes: [
      'A login without a label printer no longer blocks Warehouse Received: the order is received with 0 labels, and Inny says the labels did not print.',
      'Inny then lists the label printers that are online, so you can pick the one next to you for next time.',
    ],
  },
  {
    version: '1.13.1',
    date: '2026-11-02',
    title: 'Receive straight from a delivery note',
    notes: [
      'Delivery notes: Receive opens every order on the note together, so a big delivery of one brand over several POs is one scan session.',
    ],
  },
  {
    version: '1.13.0',
    date: '2026-11-02',
    title: 'A last check before Odoo, and parts that say so',
    notes: [
      'Confirm now shows the items Odoo would refuse (packaging not confirmed, no supplier barcode) before sending, with a one-tap fix for each: Confirm the packaging, Box has no barcode, Scan it, or leave it for the next receipt.',
      'Scanning one box of an item in several parts shows PART 1 of 2 and what is still missing, instead of a count that looks like the whole item is in.',
    ],
  },
  {
    version: '1.12.1',
    date: '2026-10-29',
    title: 'Counts reset after confirming',
    notes: [
      'Once a receipt is confirmed in Odoo, its counts start from zero again, also when you leave the result screen with the back button. Reopening the order no longer shows what was already received.',
    ],
  },
  {
    version: '1.12.0',
    date: '2026-10-29',
    title: 'Orders you missed on a delivery note',
    notes: [
      'After you save a delivery note, Inny reads it and tells you when another open order is on it: its P-number, the supplier\'s order number, or articles that belong to it.',
      'Tap Add (with its labels) and the note goes on that order too, Warehouse received included. Not in this delivery hides it.',
      'Missed orders also show under the note in the list, so they can be added later.',
    ],
  },
  {
    version: '1.11.1',
    date: '2026-10-29',
    title: 'Every delivery note, searchable',
    notes: [
      'Delivery notes: type a PO number or a supplier to find any note ever sent, and Show older notes goes back as far as you like.',
    ],
  },
  {
    version: '1.11.0',
    date: '2026-10-27',
    title: 'Receipts follow your login',
    notes: [
      'Start a receipt on one device and carry on on another with the same login: the counts are where you left them.',
      'Recently opened shows the receipts of your login, whatever device opened them.',
      'Two people on the same login can scan the same truck together: their counts add up. Everyone on that login sees the same receipts.',
    ],
  },
  {
    version: '1.10.4',
    date: '2026-10-27',
    title: 'Scanned barcode already filled in',
    notes: [
      'Linking a new barcode to a box that still has to be measured: the box sheet now opens with that barcode filled in, no need to scan it twice.',
    ],
  },
  {
    version: '1.10.3',
    date: '2026-10-27',
    title: 'Lighter on Odoo',
    notes: [
      'Inny signs in to Odoo once instead of on every request, so Odoo has less work and screens load a little faster.',
    ],
  },
  {
    version: '1.10.2',
    date: '2026-10-26',
    title: 'The screen stays upright',
    notes: [
      'Tilting the scanner downwards no longer turns the screen upside down in the installed Inny app.',
    ],
  },
  {
    version: '1.10.1',
    date: '2026-10-23',
    title: 'New orders show up everywhere',
    notes: [
      'Picking the order for a delivery note, or adding a forgotten order to a receipt, now always lists the orders confirmed since you last opened the orders list.',
    ],
  },
  {
    version: '1.10.0',
    date: '2026-10-16',
    title: 'Selfie wall, and claims found by vendor reference',
    notes: [
      'Selfie: Post on the wall puts your picture on the selfie wall below the booth, for the whole team. Tap one to see it big; yours you can take down.',
      'Claims: when the supplier prints only its own reference, Inny looks for it in the Vendor Reference of the POs and shows the claim PO, with a Receive button when it is still open.',
      'Searching orders: the vendor reference shows on each order, and slashes, dashes and spaces no longer matter (137-300 finds 137300).',
    ],
  },
  {
    version: '1.9.0',
    date: '2026-10-14',
    title: 'Claims without a PO',
    notes: [
      'A parcel for after-sales with no PO? Photos, then the Claim tab (or menu, Claim without a PO).',
      'Photograph the paperwork and the label, tap Send. Inny reads the claim reference and finds the sale in Odoo.',
      'The photos and what was found go straight to #sav-warehouse, so after-sales can tell you where it goes.',
    ],
  },
  {
    version: '1.8.0',
    date: '2026-10-12',
    title: 'No more extras by scanning',
    notes: [
      'Once a line has all its units, scanning one more carton no longer counts an extra. Inny says Already complete.',
      'It then shows the other open orders that still expect this product: Add to this delivery counts the carton there.',
      'Really an extra? Count it here anyway, or use + on the line.',
    ],
  },
  {
    version: '1.7.4',
    date: '2026-10-10',
    title: 'Add a forgotten order, and reopen recent ones',
    notes: [
      'Forgot an order on the truck? Tap + at the top of the receipt, tick it, Continue. What you already counted stays.',
      'The orders list shows Recently opened: one tap back into the same receipt.',
      'With several orders, each line shows only the PO number, so the product name keeps its room.',
    ],
  },
  {
    version: '1.7.3',
    date: '2026-10-08',
    title: 'Always a backorder',
    notes: ['The tick box to drop the missing items is gone. Whatever you do not receive always stays open on a backorder for the next pallet. Closing an order short is done in Odoo by purchasing.'],
  },
  {
    version: '1.7.2',
    date: '2026-10-08',
    title: 'Oversize and Ships on pallet when setting up a box',
    notes: [
      'When you add or edit a box, tick Oversize or Ships on pallet right there. It is saved on the product in Odoo together with the box.',
      'Oversize is back as a switch under Handling in the line sheet, and shows as a tag on the line.',
    ],
  },
  {
    version: '1.7.1',
    date: '2026-10-08',
    title: 'Packing lists that print one line per box',
    notes: [
      'When a supplier prints a product as its boxes (the Tiptoe Moka table as tabletop + structure), those lines are now matched to the product instead of being flagged.',
      'Still open on the order, not on the note: shows which note line it probably is.',
    ],
  },
  {
    version: '1.7.0',
    date: '2026-10-07',
    title: 'See what the packing list says',
    notes: [
      'Every delivery note you save is now read automatically: document number, cartons, pallets, weight, carrier, and each line with its code and quantity.',
      'Under Recent delivery notes, tap a note to see it. Each line shows the order it belongs to and what is still open; lines under another code, or not on the order, are flagged.',
      'Older notes say Not read: open one and tap Read it now.',
    ],
  },
  {
    version: '1.6.4',
    date: '2026-10-07',
    title: 'Up to 60 pages per delivery note',
    notes: ['A delivery note now takes up to 60 photos instead of 20, for big orders. Saving a long one can take a minute: keep the screen open until it says Attached.'],
  },
  {
    version: '1.6.3',
    date: '2026-10-02',
    title: 'Same barcode on several boxes of one product',
    notes: ['A product in several boxes may now carry the same barcode on more than one box (a set of 4 Tiptoe table legs). Scanning that code fills the boxes in turn: box 1, box 2, box 1, box 2.'],
  },
  {
    version: '1.6.2',
    date: '2026-10-02',
    title: 'Mixed pallet: each photo starts empty',
    notes: ['On a mixed pallet, each new photo now starts with no order ticked, so you choose its orders fresh every time.'],
  },
  {
    version: '1.6.1',
    date: '2026-10-02',
    title: 'Number pad when picking orders',
    notes: ['Pick the orders opens the number pad: type the PO number without the P. Tap ABC for letters (a supplier name), 123 to go back. Your choice is remembered on this device.'],
  },
  {
    version: '1.6.0',
    date: '2026-10-02',
    title: 'Mixed pallets on the delivery note',
    notes: [
      'The delivery note now starts with the orders, then the pages.',
      'With two orders or more, switch on Mixed pallet: after each photo, pick the orders on that page (the previous page\'s choice is ready). Each order gets a PDF with only its own pages.',
      'Off, as before: every page goes on every order.',
    ],
  },
  {
    version: '1.5.3',
    date: '2026-10-02',
    title: 'Orders with an extra on one line no longer disappear',
    notes: ['An order where one product came in once too often and another is still missing was counted as complete and left the list (P32406). It is back, with 10 other orders in the same case.'],
  },
  {
    version: '1.5.2',
    date: '2026-10-02',
    title: 'Product EAN on a carton without a barcode',
    notes: ['Scanning a product whose carton has no barcode on file no longer says "Not on this order" when the order does have it. It now says "On this order" with two buttons: Count it, or Link this code so every next scan counts by itself.'],
  },
  {
    version: '1.5.1',
    date: '2026-10-02',
    title: 'Labels per order on the delivery note',
    notes: ['The number of labels is now asked per order and answers the WAREHOUSE RECEIVED pop-up in Odoo for you, so the date + PO labels print when you save. Empty or 0 prints none.'],
  },
  {
    version: '1.5.0',
    date: '2026-10-02',
    title: 'Delivery note presses WAREHOUSE RECEIVED',
    notes: ['Saving a delivery note now also presses WAREHOUSE RECEIVED in Odoo on every order you picked, in your name: the tick, the date, the green line in the chatter and the date + PO label, exactly like the button in Odoo.'],
  },
  {
    version: '1.4.1',
    date: '2026-10-01',
    title: 'Labels count on the delivery note',
    notes: ['Delivery note has a fourth field: the number of labels to print. It is written on the PDF, in the note on each order in Odoo, and in Recent delivery notes.'],
  },
  {
    version: '1.4.0',
    date: '2026-10-01',
    title: 'Delivery notes, and a photo booth',
    notes: [
      'New camera button on the orders list. Delivery note: photograph the supplier\'s packing list page by page, pick the orders it covers, and Inny merges the pages into one PDF, attaches it to each order in Odoo with a note, and keeps it under Recent delivery notes.',
      'From an open receipt, the document icon at the top opens the delivery note with those orders already picked.',
      'Selfie: eight warehouse-approved filters. Received, Fragile, Cross-dock, Backorder, Oversize, Inny, Pallet-wrapped and Hi-vis. Share it where you like; nothing is stored.',
    ],
  },
  {
    version: '1.3.0',
    date: '2026-09-29',
    title: 'Receipts: filters and ZIP export',
    notes: [
      'Receipts and reports can be filtered by PO, supplier, person, status and dates, and paged through, newest first.',
      'Tick receipts to download them as one ZIP, or export everything that matches your filters: a PDF per receipt plus a receipts.csv list that opens in Excel.',
    ],
  },
  {
    version: '1.2.8',
    date: '2026-09-29',
    title: 'Big trucks',
    notes: [
      'Receive together stays usable with 20+ orders on the scanner: the chosen orders sit in one row you can swipe, the list keeps its room, and the start button stays on screen. The keyboard no longer pops up on open.',
      'A carton from an order that is not in your session offers "Add to this delivery": the order joins the session, everything you counted stays, and the carton is counted on it.',
    ],
  },
  {
    version: '1.2.7',
    date: '2026-09-28',
    title: 'Shipped, in the report',
    notes: [
      'The PDF report shows what the supplier reports as shipped next to expected and received, and lists separately what was shipped but did not arrive on this delivery.',
      'On the confirmation screen, a line the supplier shipped but you did not scan is marked in amber.',
    ],
  },
  {
    version: '1.2.6',
    date: '2026-09-28',
    title: 'Replacing an old EAN',
    notes: ['Linking a scanned code to a box that already carries another EAN now asks: both codes are shown, and one tap replaces the old one. Before, it refused and sent you to Odoo.'],
  },
  {
    version: '1.2.5',
    date: '2026-09-28',
    title: 'EANs on kits and no-EAN suppliers',
    notes: [
      'Ticking "no EAN from this supplier" keeps the barcode field: you can still enter a code for the label or a kit.',
      'The same EAN may now sit on boxes of different products, as a kit component does. Inny asks which product you are holding when such a code is scanned. Two boxes of one product still cannot share a code.',
    ],
  },
  {
    version: '1.2.0',
    date: '2026-09-28',
    title: 'Order size, by reason',
    notes: [
      '"Big order" now says why, with the number: Bulky 470 L, Heavy 66 kg, Many units 210, Many lines 105. Blue is informative, amber means make room or hands, red is an exceptional order worth a heads-up.',
      'Orders with many units but no packaging data are tagged too.',
    ],
  },
  {
    version: '1.1.3',
    date: '2026-09-25',
    title: 'Receipts and reports',
    notes: [
      'Every receipt confirmed from Inny, with its PDF report, is listed under "Receipts and reports" in the menu, newest first.',
      'The same PDF is attached to the purchase order in Odoo, in the chatter, under your name.',
    ],
  },
  {
    version: '1.1.2',
    date: '2026-09-25',
    title: 'Suppliers without EANs',
    notes: [
      'Toscot and others print no EAN: tick "This supplier prints no EAN on the carton" when adding box data, or "No EAN from supplier" under Handling. Inny then counts by hand, Odoo stops asking for a barcode, and the label prints after validation.',
      'Carton codes with letters or slashes, as Vibia prints them, can now be linked to a box.',
    ],
  },
  {
    version: '1.1.0',
    date: '2026-09-25',
    title: 'A fresh coat',
    notes: [
      'Glass surfaces, softer corners and buttons that answer a press: the same screens, easier on the eye.',
      'When a newer Inny is deployed, a green bar at the top offers a one-tap reload. Your counts are kept.',
    ],
  },
  {
    version: '1.0.0',
    date: '2026-09-25',
    title: 'A new Inny',
    notes: [
      'Search any order by vendor code, product EAN or box EAN, and find a line inside an order the same way.',
      'Lines show the supplier code and the box EAN. Only the vendor barcode on a box counts when scanning.',
      'Packaging has to be confirmed before a receipt is validated. Scanning an unconfirmed product opens it straight away.',
      'A carton whose EAN belongs to several products asks which one you are holding. With several orders, the oldest is filled first.',
      'Every confirmed receipt gives a PDF report. Product labels print by themselves where a label printer is set up.',
      'A calmer look: cards in zones, a compact order list, a new Inny and a clearer usage page.',
    ],
  },
];

export const LATEST = CHANGELOG[0];
